<template>
	<div>
		<layout :mastheadBackgroundImage="mastheadBg">
			<div slot="masthead" class="center">
				<masthead>
					<template slot="headline">Contact</template>
					<template slot="content">We’re here to help you with any of your questions. If you’re interested in StudySync, please go to <a href="https://www.imaginelearning.com">ImagineLearning.com</a>.</template>
				</masthead>
			</div>
			<div class="content" slot="body" ref="content">
				<FormLayout>
					<div class="content__info" slot="info">
						<div class="primary-info">
							<ul class="secondary-info">
								<li>
									<p><a target="_blank" href="https://www.imaginelearning.com/about/contact-us">Contact Imagine Learning</a> for more information about StudySync ELA.</p>
									<p>
										Imagine Learning LLC 
										<br />100 S Mill Ave. Suite 1700, 
										<br />Tempe, AZ 85281
									</p>
								</li>
								<li>
									<p>If you are a McGraw Hill StudySync user, please <a href="https://content.studysync.com/support/05/StudySyncMcGrawPartnershipFAQ.pdf">click here</a> to receive support on the below questions and more—FAQ, Tech or platform support​, Requests for more materials, Requests for training​, Questions/concerns about your StudySync product, My StudySync subscriptions are about to expire. I want to renew, and I need help!​</p>
								</li>
							</ul>
						</div>
					</div>
				</FormLayout>
			</div>
			<template slot="footer">
				<FooterCTA />
			</template>
		</layout>
	</div>
</template>

<script>

	import Layout from '@/layouts/layoutA'
	import Masthead from '@/layouts/layoutA/masthead'
	import FooterCTA from '@/components/FooterCTA'
	import ContactForm from '@/components/ContactForm'
	import FormLayout from '@/layouts/FormLayout'
	import Scroller from '@/components/AnchorNav/Scroller'

	export default {
		metaInfo: {
			title: "StudySync Contact"
		},
		data () {
			return {
				mastheadBg: require('img/mastheads/contact1.jpg')
			}
		},
		components: { Layout, Masthead, FooterCTA, ContactForm, FormLayout },
		methods: {
			scrollToContent () {
				Scroller.scrollToElement(this.$refs.content)
			}
		}
	}
</script>

<style lang="scss" scoped>

	@import "responsive-font";
	@import "list-style-reset";
	@import "media";

	.content {
		@include responsive-font(10);
		@include media(small,xlarge) {
			background:#F6F8F9; padding-bottom:30px;
			& > * {
				padding-top:30px;
			}
		}
		@include media(xlarge) {
			& > * {
				background:#F6F8F9;
			}
		}

		.section-icon {
			display:inline-block; width:4.2rem; height:4.2rem;
			@include media(xlarge) {
				margin-bottom:1.6rem;
			}
		}

		.primary-info {
			@include responsive-font(25);
			line-height:1.4; color:#3D3D3D;
			p {
				margin:0;
			}
			p + p {
				margin-top:1em;
			}
			a {
				color:inherit;
			}
		}

		.secondary-info {
			@include list-style-reset;
			@include responsive-font(18);
			padding-top: 5rem;
			color:#6D6E71;
			li + li {
				margin-top:2em;
			}
			h4 {
				@include responsive-font(12);
				font-family:'proxima-nova'; font-weight:600; letter-spacing:.075em; text-transform:uppercase; color:#FDB913;
			}
			p {
				margin:.25em 0 0;
			}
			a {
				color:inherit;
			}
		}

	}

</style>



// WEBPACK FOOTER //
// src/routes/contact/index.vue